// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import { Container, Stack, Typography } from '@mui/material';

// api
import { useGetDaluxApiKeyQuery } from '@/api/dalux-integration/daluxIntegrationApiSlice';

// components
import DaluxApiKeyCard from '@/features/dalux-integration/DaluxApiKeyCard';
import DaluxTicketsDatagrid from '@/features/dalux-integration/DaluxTicketsDatagrid';
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_admin/dalux-integration/')({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
});

function RouteComponent() {
  const { t } = useTranslation('dalux-integration');
  const { accountId } = useParams({ strict: false });
  const { data: keyData, isLoading } = useGetDaluxApiKeyQuery(undefined, {
    skip: !accountId,
  });
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Stack spacing={3}>
        <Typography variant="h5" fontWeight="bold">
          {t('title')}
        </Typography>
        <DaluxApiKeyCard accountId={accountId} />

        {keyData && !isLoading && (
          <DaluxTicketsDatagrid accountId={accountId} />
        )}
      </Stack>
    </Container>
  );
}
